import React from 'react';
import { Typography, CircularProgress, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import { useNavigate, useResolvedPath } from 'react-router-dom';
import { skipToken } from '@reduxjs/toolkit/query';
import FeedbackIcon from '@mui/icons-material/Feedback';
import Alert from './styles/Alert';
import Container from './styles/Container';
import Wrapper from './styles/Wrapper';
import { useGetLogisticTaskAdviceStatsQuery } from '../../../entities/logistic/logisticTasks/redux/logisticTasks.api';

const POLL_INTERVAL = 30000;

const PRIORITY_ORDER = ['critical', 'high', 'medium', 'low'];

const PRIORITY_LABELS = {
  critical: 'критического',
  high: 'высокого',
  medium: 'среднего',
  low: 'низкого',
};

function AdvicesInfoSection({ logisticTaskId }) {
  const base = useResolvedPath('..');
  const navigate = useNavigate();
  const { data, isLoading, isError } = useGetLogisticTaskAdviceStatsQuery(
    logisticTaskId ? { id: logisticTaskId } : skipToken,
    {
      pollingInterval: POLL_INTERVAL,
    },
  );

  if (isLoading) return <CircularProgress size={32} sx={{ margin: 'auto' }} />;

  const allAdvicesZero = data?.stat && Object.values(data.stat).every((count) => count === 0);

  if (isError || !data || allAdvicesZero) return null;

  const priorities = Object.entries(data.stat)
    .filter(([, count]) => count > 0)
    .sort(([a], [b]) => PRIORITY_ORDER.indexOf(a) - PRIORITY_ORDER.indexOf(b));

  return (
    <Alert severity="info" color="warning" onClick={() => navigate(`${base.pathname}/advices`)}>
      <Container>
        <Typography>Рекомендации:</Typography>
        {priorities.map(([priority, count]) => (
          <Tooltip key={priority} title={`Рекомендаций ${PRIORITY_LABELS[priority]} приоритета`}>
            <Wrapper priority={priority}>
              <FeedbackIcon fontSize="small" />
              <Typography>{count}</Typography>
            </Wrapper>
          </Tooltip>
        ))}
      </Container>
    </Alert>
  );
}

AdvicesInfoSection.propTypes = {
  logisticTaskId: PropTypes.string.isRequired,
};

export default AdvicesInfoSection;
